import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';


const TaxJurisdictions = () => {
  const [jurisdictions, setJurisdictions] = useState([
    {
      id: 1,
      name: 'New York State',
      type: 'State',
      taxTypes: ['Sales Tax', 'Income Tax'],
      rate: '8.875%',
      nexus: true,
      filingFrequency: 'Quarterly',
      lastFiled: '2025-12-31'
    },
    {
      id: 2,
      name: 'Federal - IRS',
      type: 'Federal',
      taxTypes: ['Income Tax', 'Payroll Tax'],
      rate: 'Variable',
      nexus: true,
      filingFrequency: 'Quarterly',
      lastFiled: '2025-12-31'
    },
    {
      id: 3,
      name: 'California',
      type: 'State',
      taxTypes: ['Sales Tax'],
      rate: '7.25%',
      nexus: false,
      filingFrequency: 'Monthly',
      lastFiled: 'N/A'
    }
  ]);

  const [showAddModal, setShowAddModal] = useState(false);

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">Tax Jurisdictions</h2>
          <p className="text-sm text-gray-600 mt-1">Manage tax jurisdictions and nexus status</p>
        </div>
        <Button iconName="Plus" onClick={() => setShowAddModal(true)}>
          Add Jurisdiction
        </Button>
      </div>
      {/* Jurisdictions Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {jurisdictions?.map((jurisdiction) => (
          <div
            key={jurisdiction?.id}
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
          >
            <div className="flex items-start justify-between mb-4">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">{jurisdiction?.name}</h3>
                <span className="inline-block px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800 mt-1">
                  {jurisdiction?.type}
                </span>
              </div>
              <div className="flex items-center gap-2">
                {jurisdiction?.nexus && (
                  <span className="px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                    Nexus
                  </span>
                )}
                <Button variant="ghost" size="sm" iconName="MoreVertical" />
              </div>
            </div>

            <div className="space-y-3">
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">Tax Rate:</span>
                <span className="font-semibold text-gray-900">{jurisdiction?.rate}</span>
              </div>

              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">Filing Frequency:</span>
                <span className="font-semibold text-gray-900">{jurisdiction?.filingFrequency}</span>
              </div>

              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">Last Filed:</span>
                <span className="font-semibold text-gray-900">{jurisdiction?.lastFiled}</span>
              </div>

              <div className="pt-2 border-t border-gray-200">
                <span className="text-sm text-gray-600">Tax Types:</span>
                <div className="flex flex-wrap gap-2 mt-2">
                  {jurisdiction?.taxTypes?.map((type, index) => (
                    <span
                      key={index}
                      className="px-2 py-1 text-xs font-medium rounded bg-gray-100 text-gray-800"
                    >
                      {type}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex gap-2 mt-4">
              <Button variant="outline" size="sm" iconName="Edit" fullWidth>
                Edit
              </Button>
              <Button variant="outline" size="sm" iconName="FileText" fullWidth>
                View Returns
              </Button>
            </div>
          </div>
        ))}
      </div>
      {/* Nexus Tracking Info */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} className="text-blue-600 mt-0.5" />
          <div>
            <h4 className="text-sm font-semibold text-blue-900 mb-1">About Nexus</h4>
            <p className="text-sm text-blue-800">
              Nexus is the connection between your business and a tax jurisdiction that creates a tax obligation. 
              Enable nexus tracking for jurisdictions where you have physical presence, employees, or significant sales.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxJurisdictions;